import {
  AppBar,
  Avatar,
  Badge,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  ClickAwayListener,
  Divider,
  Grow,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Popper,
  Toolbar,
  Typography,
} from "@material-ui/core";
import ListSubheader from "@material-ui/core/ListSubheader";
import { withStyles } from "@material-ui/core/styles";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import BookingIcon from "@material-ui/icons/Layers";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/Notifications";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import classNames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Cookies } from "react-cookie";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import queryString from "query-string";
import {
  getBrowserName,
  MasspaLanguage,
  TokenExpires,
} from "../../utils/setting";
import ChangeLanguage from "../changeLanguage";
import Logo from "../logo";
import { styles } from "./styles";
import packageFile from '../../../package.json'

const cookie = new Cookies();

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      anchorElLanguage: null,
      anchorElReportProplem: null,
      openMenuLanguage: false,
      openMenuNotification: false,
      openMenuReportProplem: false,
      locationPermission: true,
      notificationPermission: true,
    };
  }
  componentDidMount() {
    const { i18n } = this.props;
    let lang = cookie.get(MasspaLanguage);
    this.getListReceivedNotification();
    if (
      getBrowserName(navigator).toLowerCase() !== "safari" &&
      getBrowserName(navigator).toLowerCase() !== "internet explorer"
    ) {
      this.checkPermissionBrowser();
    }
    if (lang) {
      i18n.changeLanguage(lang);
      cookie.set(MasspaLanguage, lang, {
        path: "/",
        expires: new Date(Date.now() + TokenExpires),
      });
    }
  }
  checkPermissionBrowser = () => {
    let _this = this;
    navigator.permissions
      .query({ name: "notifications" })
      .then(function (result) {
        if (result.state == "denied") {
          _this.setState({
            notificationPermission: false,
          });
        }
      });
    navigator.permissions
      .query({ name: "geolocation" })
      .then(function (result) {
        if (result.state == "denied") {
          _this.setState({
            locationPermission: false,
          });
        }
      });
  };
  getListReceivedNotification = async () => {
    await this.props.getListReceivedNotification({
      limit: 3,
      page: 0,
      sort: { createdAt: -1 },
    });
  };
  handleLogout = async () => {
    this.props.logout({ push: this.props.history.push });
    this.handleClose();
  };

  handleToggle = (event) => {
    event.preventDefault();
    this.setState({ openMenu: !this.state.openMenu });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
    this.setState({ openMenu: false });
  };
  handleToggleLanguage = (event) => {
    event.preventDefault();
    this.setState({ openMenuLanguage: !this.state.openMenuLanguage });
  };
  handleToggleNotification = (event) => {
    event.preventDefault();
    if (!this.state.openMenuNotification) this.getListReceivedNotification();
    this.setState({ openMenuNotification: !this.state.openMenuNotification });
  };
  handleToggleReportProplem = (event) => {
    event.preventDefault();
    this.setState({ openMenuReportProplem: !this.state.openMenuReportProplem });
  };
  handleCloseLanguage = () => {
    this.setState({ anchorElLanguage: null });
    this.setState({ openMenuLanguage: false });
  };
  handleCloseNotification = () => {
    this.setState({ anchorElNotification: null });
    this.setState({ openMenuNotification: false });
  };
  handleCloseReportProplem = () => {
    this.setState({ anchorElReportProplem: null });
    this.setState({ openMenuReportProplem: false });
  };
  changeLanguage = (lang) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lang);
    this.handleCloseLanguage();
    cookie.set(MasspaLanguage, lang, {
      path: "/",
      expires: new Date(Date.now() + TokenExpires),
    });
  };
  timeAgo = (milisecond) => {
    return moment(milisecond).fromNow();
  };
  handlePage = (notification) => {
    let ids = [notification._id];
    this.setState({ openMenuNotification: false });
    this.props.updateReader({ ids: ids });
    this.getListReceivedNotification();
    this.props.history.push("/notification");
  };
  seeAll = () => {
    const { listReceivedNotification } = this.props;
    this.setState({ openMenuNotification: false });
    this.props.history.push("/notification");
  };
  handleSelect = () => {
    this.props.handleSelected("");
  };
  render() {
    const {
      openMenu,
      openMenuNotification,
      openMenuReportProplem,
      notificationPermission,
      locationPermission,
    } = this.state;
    const {
      classes,
      t,
      listReceivedNotification,
      totalReceivedNotification,
      user,
    } = this.props;
    const fullName = user.firstName.concat(" ", user.lastName);
    const { roleId } = user;
    let notificationRead = listReceivedNotification.filter((item) => {
      return item.serviceRead.indexOf(roleId.serviceCode) !== -1;
    }); // Thông báo đã đọc
    return (
      <AppBar
        color="secondary"
        position="absolute"
        className={classNames(classes.appBar)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={() => {
              this.props.handleDrawer();
            }}
            className={classNames(classes.menuButton)}
          >
            <MenuIcon />
          </IconButton>
          <Link to="/" onClick={() => this.handleSelect()}>
            <div className={classes.spaName}>
              <div className={classes.logo}>
                <Logo />
              </div>
              <div>
                <Typography variant="body1" color="inherit" noWrap>
                  MASSPA
                </Typography>
                <div style={{ fontSize: "0.7rem" }}>vAdmin: {packageFile.version}. vAPI: {this.props.versionAPI}</div>
              </div>
            </div>
          </Link>
          <div className={classes.right}>
            <ChangeLanguage header={true} />
            <IconButton
              buttonRef={(node) => {
                this.anchorElNotification = node;
              }}
              aria-owns={openMenu ? "menu-appbar" : null}
              aria-haspopup="true"
              onClick={this.handleToggleNotification}
              color="inherit"
            >
              <Badge
                badgeContent={
                  totalReceivedNotification - notificationRead.length
                }
                max={99}
                color="primary"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <Popper
              open={openMenuNotification}
              anchorEl={this.anchorElNotification}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  id="menu-appbar"
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener
                      onClickAway={this.handleCloseNotification}
                    >
                      <Card className={classes.card}>
                        <CardContent className={classes.customCardContend}>
                          <div className={classes.titleNoti}>
                            <Typography
                              gutterBottom
                              variant="subtitle1"
                              component="subtitle1"
                            >
                              {t("sidebar_notification")}
                            </Typography>
                          </div>
                          <Divider />
                          <List>
                            {listReceivedNotification.map((ele, index) => {
                              let isRead = notificationRead.findIndex(
                                (item) => item._id === ele._id
                              );
                              return (
                                <ListItem
                                  key={index}
                                  button
                                  divider={true}
                                  onClick={() => this.handlePage(ele)}
                                  style={
                                    isRead === -1
                                      ? {
                                        backgroundColor:
                                          "rgba(163, 164, 168, 0.1)",
                                      }
                                      : {}
                                  }
                                >
                                  <ListItemAvatar>
                                    <Avatar>
                                      <BookingIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    classes={{
                                      primary:
                                        classes.customListItemTextPrimary,
                                      secondary:
                                        classes.customListItemTextSecondary,
                                    }}
                                    // primary={ele.description}
                                    primary={
                                      <span
                                        style={
                                          isRead === -1
                                            ? {
                                              fontWeight: "550",
                                            }
                                            : {}
                                        }
                                      >
                                        {ele.description}
                                      </span>
                                    }
                                    secondary={this.timeAgo(ele.createdAt)}
                                  />
                                  <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="delete">
                                      <ArrowForwardIosIcon />
                                    </IconButton>
                                  </ListItemSecondaryAction>
                                </ListItem>
                              );
                            })}
                          </List>
                        </CardContent>
                        <CardActions className={classes.customCardActions}>
                          <Button size="small" onClick={this.seeAll}>
                            {t("read_all")}
                          </Button>
                        </CardActions>
                      </Card>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            {(!locationPermission || !notificationPermission) && (
              <IconButton
                buttonRef={(node) => {
                  this.anchorElReportProplem = node;
                }}
                aria-owns={openMenu ? "menu-appbar" : null}
                aria-haspopup="true"
                onClick={this.handleToggleReportProplem}
                color="inherit"
              >
                <ReportProblemIcon />
              </IconButton>
            )}
            <Popper
              open={openMenuReportProplem}
              anchorEl={this.anchorElReportProplem}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  id="menu-appbar"
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener
                      onClickAway={this.handleCloseReportProplem}
                    >
                      <Card className={classes.card}>
                        <CardContent className={classes.customCardContend}>
                          <div className={classes.titleNoti}>
                            <Typography
                              gutterBottom
                              variant="subtitle1"
                              component="subtitle1"
                            >
                              {t("header_permission")}
                            </Typography>
                          </div>
                          <Divider />
                          {/* <List  className={classes.root}> */}
                          <List
                            subheader={
                              <ListSubheader>
                                {t("header_your_browser_blocked_permission")}
                              </ListSubheader>
                            }
                            className={classes.root}
                          >
                            {!notificationPermission && (
                              <ListItem>
                                <ListItemIcon>
                                  <NotificationsIcon />
                                </ListItemIcon>
                                <ListItemText
                                  id="switch-list-label-wifi"
                                  primary={t("header_notification")}
                                />
                                <ListItemSecondaryAction>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="secondary"
                                    className={classes.margin}
                                  >
                                    {t("header_block")}
                                  </Button>
                                </ListItemSecondaryAction>
                              </ListItem>
                            )}
                            {!locationPermission && (
                              <ListItem>
                                <ListItemIcon>
                                  <LocationOnIcon />
                                </ListItemIcon>
                                <ListItemText
                                  id="switch-list-label-wifi"
                                  primary={t("header_location")}
                                />
                                <ListItemSecondaryAction>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="secondary"
                                    className={classes.margin}
                                  >
                                    {t("header_block")}
                                  </Button>
                                </ListItemSecondaryAction>
                              </ListItem>
                            )}
                          </List>
                        </CardContent>
                      </Card>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            <div className={classes.fullName}>
              <Typography variant="body1" color="inherit" noWrap>
                {fullName}
              </Typography>
            </div>
            <IconButton
              buttonRef={(node) => {
                this.anchorEl = node;
              }}
              aria-owns={openMenu ? "menu-appbar" : null}
              aria-haspopup="true"
              onClick={this.handleToggle}
              color="inherit"
            >
              {/* <AccountCircle /> */}
              {user.avatarImage ? (
                <Avatar
                  alt="Avatar"
                  src={user.avatarImage}
                  className={classes.avatar}
                />
              ) : (
                  <Avatar
                    className={classNames(classes.avatar, classes.smallAvatar)}
                  >
                    {fullName.charAt(0).toLocaleUpperCase() || "M"}
                  </Avatar>
                )}
            </IconButton>

            <Popper
              open={openMenu}
              anchorEl={this.anchorEl}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  id="menu-appbar"
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={this.handleClose}>
                      {/* <MenuList>
                                            <MenuItem onClick={this.handleClose}>Profile</MenuItem>
                                            <MenuItem onClick={this.handleLogout}>Logout</MenuItem>
                                        </MenuList> */}

                      <Card className={classes.card}>
                        <CardHeader
                          className={classes.cardHeader}
                          classes={{
                            subheader: classes.subheader,
                          }}
                          avatar={
                            user.avatarImage ? (
                              <Avatar
                                alt="Avatar"
                                src={user.avatarImage}
                                className={classNames(
                                  classes.avatar,
                                  classes.bigAvatar
                                )}
                              />
                            ) : (
                                <Avatar
                                  className={classNames(
                                    classes.avatar,
                                    classes.bigAvatar
                                  )}
                                >
                                  {fullName.charAt(0)}
                                </Avatar>
                              )
                          }
                          title={fullName}
                          subheader={user.email}
                        />
                        <CardActions>
                          <Link to="/profile">
                            <Button
                              onClick={() => {
                                this.handleClose();
                              }}
                              size="small"
                              color="primary"
                            >
                              {t("header_profile")}
                            </Button>
                          </Link>
                          <Button
                            size="small"
                            color="primary"
                            onClick={this.handleLogout}
                          >
                            {t("header_logout")}
                          </Button>
                        </CardActions>
                      </Card>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listReceivedNotification: state.notification.listReceivedNotification,
  totalReceivedNotification: state.notification.totalReceivedNotification,
  user: state.user.user,
  versionAPI: state.setting.version
});

const mapDispatch = (dispatch) => ({
  logout: dispatch.user.logout,
  getListReceivedNotification:
    dispatch.notification.getListReceivedNotification,
  updateReader: dispatch.notification.updateReader,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Header)));
